import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { unifiedColors } from 'styles/colors'
import { themeUtils } from 'styles/theme'

interface NavbarStyleProps {
  $rounded?: boolean
  $isFullHeader?: boolean
}

export const NavbarStyle = styled.div<NavbarStyleProps>`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  justify-content: space-between;
  gap: 30px;
  align-items: center;
  position: relative;
  width: 100%;
  border-radius: 120px;
  z-index: 1;

  ${({ $rounded }: NavbarStyleProps) =>
    $rounded &&
    css`
      background: ${unifiedColors.surface.subdued};
      padding: 0 41px;
    `}

  ${themeUtils.minWidth.md} {
    height: 72px;
  }
  ${themeUtils.maxWidth.lg} {
    padding: 8px 16px;
    border-radius: 24px;
    column-gap: 16px;
  }
  ${themeUtils.maxWidth.md} {
    grid-template-columns: auto;
    row-gap: ${({ $isFullHeader }) => ($isFullHeader ? '0' : '8px')};
  }
`

export const BannerContainer = css`
  position: relative;
  display: flex;
  height: 550px;
  object-fit: cover;
`
